"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HmoRecordLicenceHolder$ = exports.HmoRecordLicenceHolder$outboundSchema = exports.HmoRecordLicenceHolder$inboundSchema = void 0;
exports.hmoRecordLicenceHolderToJSON = hmoRecordLicenceHolderToJSON;
exports.hmoRecordLicenceHolderFromJSON = hmoRecordLicenceHolderFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.HmoRecordLicenceHolder$inboundSchema = z.object({
    licence_holder_address: z.nullable(z.string()),
    licence_holder_name: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "licence_holder_address": "licenceHolderAddress",
        "licence_holder_name": "licenceHolderName",
    });
});
/** @internal */
exports.HmoRecordLicenceHolder$outboundSchema = z.object({
    licenceHolderAddress: z.nullable(z.string()),
    licenceHolderName: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        licenceHolderAddress: "licence_holder_address",
        licenceHolderName: "licence_holder_name",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var HmoRecordLicenceHolder$;
(function (HmoRecordLicenceHolder$) {
    /** @deprecated use `HmoRecordLicenceHolder$inboundSchema` instead. */
    HmoRecordLicenceHolder$.inboundSchema = exports.HmoRecordLicenceHolder$inboundSchema;
    /** @deprecated use `HmoRecordLicenceHolder$outboundSchema` instead. */
    HmoRecordLicenceHolder$.outboundSchema = exports.HmoRecordLicenceHolder$outboundSchema;
})(HmoRecordLicenceHolder$ || (exports.HmoRecordLicenceHolder$ = HmoRecordLicenceHolder$ = {}));
function hmoRecordLicenceHolderToJSON(hmoRecordLicenceHolder) {
    return JSON.stringify(exports.HmoRecordLicenceHolder$outboundSchema.parse(hmoRecordLicenceHolder));
}
function hmoRecordLicenceHolderFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.HmoRecordLicenceHolder$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'HmoRecordLicenceHolder' from JSON`);
}
//# sourceMappingURL=hmorecordlicenceholder.js.map